import { useAppSelector } from 'shared/hooks'

import { appSelectors } from '../../../redux/reducers/app'

declare global {
	interface Window {
		fastspring: {
			builder: any
		}
	}
}

export function useCheckout() {
	const persona = useAppSelector(appSelectors.appProfile)

	return (subscriptionPath: string, coupon = null) => {
		if (!persona) {
			return
		}
		const session = {
			coupon,
			paymentContact: {
				country: 'LI',
				email: persona.email,
				firstName: persona.givenName,
				lastName: persona.familyName
			},
			products: [
				{
					path: subscriptionPath,
					quantity: 1
				}
			],
			reset: true,
			tags: {
				ownerId: persona.personaId,
				personaId: persona.personaId,
				version: '1.0'
			}
		}
		window.fastspring.builder.push(session)
		window.fastspring.builder.checkout()
	}
}
